import admin from "./admin";
import welcome from "./welcome";
import dashboardPrincipal from "./dashboard/principal";
import dashboardRankings from "./dashboard/rankings";
import ordersGroup from "./ordersGroup";
import history from "./orders/history";
import paymentHistory from "./orders/paymentHistory";
import cierresDeCajaZ from "./orders/cierresDeCajaZ";
import orderCartas from "./menus/orderCartas";
import createOrder from "./orders/createOrder";
import createOrderSuccess from "./orders/success";
import cartas from "./menus/cartas";
import menuGroup from "./menus/menuGroup";
import ordersOpen from "./orders/ordersOpen";
import scheduleMain from "./schedule/main";
import scheduleMenu from "./schedule/menu";
import scheduleMenuGroup from "./schedule/menuGroup";
import products from "./products/list";
import categories from "./products/categories";
import subcategories from "./products/subcategories";
import groupOrders from "./products/groupOrders";
import printingRoutes from "./printers/printingRoutes";
import printersList from "./printers/list";
import cashDrawers from "./printers/cashDrawers";
import tablesQrList from "./tablesQR/list";
import zoneTablesQR from "./tablesQR/zones";
import generatorQR from "./tablesQR/generatorQR";
import usersList from "./users/list";
import translateDrink from "./translate/drink";
import translateFood from "./translate/food";
import translateDessert from "./translate/dessert";
import translateCategory from "./translate/category";
import translateSubcategory from "./translate/subcategory";
import translateCartas from "./translate/cartas";
import translateMenus from "./translate/menus";
import settingsConfig from "./settings/config";
import settingsInfo from "./settings/info";
import maintenance from "./settings/maintenance";
import settingsImages from "./settings/images";
import settingsTheme from "./settings/theme";
import sendEmail from "./settings/sendEmail";
import loggerHistory from "./logs/history";
import printerErrors from "./logs/printerErrors";
import printerHistory from "./logs/printerHistory";

export default [
  {
    ...admin,
    children: [
      welcome,
      ordersGroup,
      dashboardPrincipal,
      dashboardRankings,
      history,
      paymentHistory,
      cierresDeCajaZ,
      orderCartas,
      createOrder,
      createOrderSuccess,
      cartas,
      menuGroup,
      ordersOpen,
      scheduleMain,
      scheduleMenu,
      scheduleMenuGroup,
      products,
      categories,
      subcategories,
      groupOrders,
      tablesQrList,
      zoneTablesQR,
      generatorQR,
      usersList,
      printingRoutes,
      printersList,
      cashDrawers,
      translateDrink,
      translateFood,
      translateDessert,
      translateCategory,
      translateSubcategory,
      translateCartas,
      translateMenus,
      settingsConfig,
      settingsInfo,
      maintenance,
      settingsImages,
      settingsTheme,
      sendEmail,
      loggerHistory,
      printerErrors,
      printerHistory
    ]
  }
];
